module.exports = require("@swa-ui/dotcom/src/DotcomHeader/DotcomHeaderDesktop/DotcomHeaderDesktop.module.scss");